import React from 'react';

import PlaceholderTab from '../../shared/PlaceholderTab';

import { BUNDLED_EXPERIENCE_FIELDS } from './fields';

export default function BundledExperiencesTab() {
  return <PlaceholderTab configuredFieldCount={BUNDLED_EXPERIENCE_FIELDS.length} title="Bundled Experiences" />;
}
